import { PureOriginIcon } from '@components/ui/InvoiceOriginIcon'

import { INVOICE_ORIGINS } from '@constants'

import {
  BillingoOriginMessage,
  BrowserAddonOriginMessage,
  EmailOriginMessage,
  SzamlazzNAVOriginMessage,
  SzamlazzOriginMessage,
  UploadOriginMessage,
} from '@messages'

type OriginFilterConfig = Record<InvoiceOrigin, boolean>

const DEFAULT_ORIGIN_FILTER_CONFIG: OriginFilterConfig = {
  [INVOICE_ORIGINS.SZAMLAZZ]: true,
  [INVOICE_ORIGINS.NAV]: true,
  [INVOICE_ORIGINS.BILLINGO]: true,
  [INVOICE_ORIGINS.NOSZ]: true,
  [INVOICE_ORIGINS.EMAIL]: true,
  [INVOICE_ORIGINS.UPLOAD]: true,
  [INVOICE_ORIGINS.BROWSER_ADDON]: true,
}

export function getOriginFilters(config: Partial<OriginFilterConfig> = DEFAULT_ORIGIN_FILTER_CONFIG) {
  const options = []

  if (config[INVOICE_ORIGINS.SZAMLAZZ] ?? DEFAULT_ORIGIN_FILTER_CONFIG[INVOICE_ORIGINS.SZAMLAZZ]) {
    options.push({
      value: INVOICE_ORIGINS.SZAMLAZZ,
      label: SzamlazzOriginMessage,
      icon: <PureOriginIcon origin={INVOICE_ORIGINS.SZAMLAZZ} />,
    })
  }

  if (config[INVOICE_ORIGINS.NAV] ?? DEFAULT_ORIGIN_FILTER_CONFIG[INVOICE_ORIGINS.NAV]) {
    options.push({
      value: INVOICE_ORIGINS.NAV,
      label: SzamlazzNAVOriginMessage,
      icon: <PureOriginIcon origin={INVOICE_ORIGINS.NAV} />,
    })
  }

  if (config[INVOICE_ORIGINS.BILLINGO] ?? DEFAULT_ORIGIN_FILTER_CONFIG[INVOICE_ORIGINS.BILLINGO]) {
    options.push({
      value: INVOICE_ORIGINS.BILLINGO,
      label: BillingoOriginMessage,
      icon: <PureOriginIcon origin={INVOICE_ORIGINS.BILLINGO} />,
    })
  }

  if (config[INVOICE_ORIGINS.EMAIL] ?? DEFAULT_ORIGIN_FILTER_CONFIG[INVOICE_ORIGINS.EMAIL]) {
    options.push({
      value: INVOICE_ORIGINS.EMAIL,
      label: EmailOriginMessage,
      icon: <PureOriginIcon origin={INVOICE_ORIGINS.EMAIL} />,
    })
  }

  if (config[INVOICE_ORIGINS.UPLOAD] ?? DEFAULT_ORIGIN_FILTER_CONFIG[INVOICE_ORIGINS.UPLOAD]) {
    options.push({
      value: INVOICE_ORIGINS.UPLOAD,
      label: UploadOriginMessage,
      icon: <PureOriginIcon origin={INVOICE_ORIGINS.UPLOAD} />,
    })
  }

  if (config[INVOICE_ORIGINS.BROWSER_ADDON] ?? DEFAULT_ORIGIN_FILTER_CONFIG[INVOICE_ORIGINS.BROWSER_ADDON]) {
    options.push({
      value: INVOICE_ORIGINS.BROWSER_ADDON,
      label: BrowserAddonOriginMessage,
      icon: <PureOriginIcon origin={INVOICE_ORIGINS.BROWSER_ADDON} />,
    })
  }

  return options
}
